/* eslint-disable max-len */
import React, { Fragment } from 'react';
import { Select, Input, Divider, Upload, Button, Icon, Form, Alert, Space, Row, Col } from 'antd';
import LayoutRow from './LayoutRow';
import EndPoints from '../EndPoints';
import useInput from '../hooks/UseInput';
import useSelect from '../hooks/UseSelect';
import useTitle from '../hooks/UseTitle';
import useUpload from '../hooks/UseUpload';
import usePost from '../hooks/UsePost';
import Utils from '../Utils';
import Notifications from './Notifications';
import Analytics from '../services/Analytics';

const units = { KB: 'kb', MB: 'mb' };

const CompressToSize = () => {
	useTitle('Compress JPG to 50KB, 100KB, 200KB (2022)');
	const { Option } = Select;
	const [value, setValue, bind] = useInput(undefined);
	const [valueUnit, setValueUnit, bindPredefinedValue] = useSelect(units.KB);
	const [fileList, uploadResponse, beforeUpload, onChange] =
		useUpload(Utils.isJpeg, Notifications.onlyJPGFilesAllowed, Notifications.serverError);
	const params = { fileName: uploadResponse,
		size: valueUnit === units.KB ? value : value * 1024,
		originalFilename: fileList[0] ? fileList[0].name : '' };
	const [post, pending, response, error] = usePost(EndPoints.CompressToSize, params, Analytics.onCompressToSize);
	const showErrorMessage = response && response.files[0] && response.files[0].errorText;
	const showSuccessMessage = response && response.files[0] && !showErrorMessage && response.files[0].name === uploadResponse;
	const unitSelect = (
		<Select {...bindPredefinedValue} style={{ width: 70 }}>
			<Option value="kb">KB</Option>
			<Option value="mb">MB</Option>
		</Select>
	);
	function onClickOption(e, size) {
		e.preventDefault();
		if (size < 1024) {
			setValue(size);
			setValueUnit(units.KB);
		} else {
			setValue(size / 1024);
			setValueUnit(units.MB);
		}
	}
	function validateStatus() {
		if (fileList.length === 0 || !value) return 'success';
		const sizeInKb = valueUnit === units.KB ? value : value * 1024;
		return (fileList[0].size / 1024 > sizeInKb) ? 'success' : 'error';
	}
	const errorMsg = validateStatus() === 'success' ? '' : 'Should be less than size of file uploaded.';
	function onDownload() {
		const filePath = response.files[0].compressedFilePath.replace('/var/www/images', '/images/');
		window.open(filePath, '_self');
	}

	return (
		<Fragment>
			<LayoutRow className="compress-to-size">
				<h1>Reduce JPG image size to 20kb, 50KB, 100kb or any other fixed size in KB or MB</h1>
				<p>
					You can use this tool to reduce size of jpg images to a
					fixed size in Kilobytes (KB) or Megabytes (MB).
				</p>
				<Row>
					<Col xs={24} sm={24} md={18}>
						<Upload
							accept=".jpg, .jpeg"
							listType="picture"
							fileList={fileList}
							action={EndPoints.Upload}
							beforeUpload={beforeUpload}
							showUploadList={{ showPreviewIcon: false, showDownloadIcon: false, showRemoveIcon: false }}
							onChange={onChange}
						>
							<Button>
								<Icon type="upload" /> Choose File
							</Button>
						</Upload>
						<p style={{ marginTop: '8px' }}>
							{ fileList[0] && <Alert message={`Size of uploaded file ${Utils.formatLength(fileList[0].size)}`} type="info" />}
						</p>
					</Col>
				</Row>
				<Divider orientation="left">Enter desired file size</Divider>
				<a href="#20kb" onClick={e => { onClickOption(e, 20); }}>Compress JPG to 20KB</a>
				<a href="#50kb" onClick={e => { onClickOption(e, 50); }}>Compress JPG to 50KB</a>
				<a href="#100kb" onClick={e => { onClickOption(e, 100); }}>Compress JPG to 100KB</a>
				<a href="#200kb" onClick={e => { onClickOption(e, 200); }}>Compress JPG to 200KB</a>
				<a href="#200kb" onClick={e => { onClickOption(e, 500); }}>Compress JPG to 500KB</a>
				<br /><br />
				{showSuccessMessage &&
				<Fragment>
					<Row>
						<Col xs={24} sm={24} md={18} >
							<Alert
								message={`File compressed to ${response.files[0].size}.`}
								type="success"
								action={
									<Space>
										<Button size="small" onClick={onDownload}>
											Download
										</Button>
									</Space>
								}
							/>
						</Col>
					</Row>
					<br />
				</Fragment>}
				{showErrorMessage &&
				<Fragment>
					<Alert message={response.files[0].errorText} type="error" />
					<br />
				</Fragment>}
				<Form className="cts-form">
					<Form.Item required help={errorMsg} validateStatus={validateStatus()}>
						<Input className="size-input" addonBefore="Size" addonAfter={unitSelect} type="number" {...bind} />
					</Form.Item>
					<Button
						loading={pending}
						type="primary"
						disabled={!(uploadResponse && value > 0 && validateStatus() === 'success')}
						htmlType="submit"
						onClick={post}
					>
						Compress
					</Button>
					{/* {response && showSuccessMessage && <Button onClick={onDownload}>Download</Button>} */}
				</Form>
				<small style={{ marginTop: '8px', marginBottom: '8px', display: 'inline-block' }} >
					Last updated March, 2022. Bug fixes. Performance improvements.
				</small>
			</LayoutRow>
		</Fragment>
	);
};

export default CompressToSize;



// WEBPACK FOOTER //
// ./src/components/CompressToSize.js